<template>
  <div>
    <div style="position: relative">
      <page-header
        class="mb-6"
        :header-title="$t('IMPORT_WIZARD.STEP_4.TITLE')"
        :header-content="$t('IMPORT_WIZARD.STEP_4.DESC')"
      />

      <div class="label--export-process text-sm text-slate-400 my-2">
        {{ $t(`IMPORT_WIZARD.STEP_4.STATUS.${status}`) }}
        <div v-if="status === 'failed'" class="text-red-300">
          {{ getStatusInfo.message }}
        </div>
        <span v-else-if="getStatusInfo"> ({{ getStatusInfo.message }}) </span>
      </div>

      <div class="label--export-process text-sm text-slate-400 my-2">
        <woot-button
          v-if="status === 'processing'"
          class="label--export-process text-sm text-slate-400 my-2"
          color-scheme="alert"
          @click="stopImport"
        >
          {{ $t(`IMPORT_WIZARD.STEP_4.STOP_IMPORT`) }}
        </woot-button>
      </div>
      <spinner v-if="isImportInProcess"> Processing ... </spinner>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Spinner from 'shared/components/Spinner.vue';
import PageHeader from 'dashboard/routes/dashboard/settings/SettingsSubPageHeader.vue';
export default {
  components: { PageHeader, Spinner },
  data() {
    return {
      refreshTimer: undefined,
    };
  },
  computed: {
    ...mapGetters({
      getStatusInfo: 'importWizard/getStatusInfo',
    }),
    isImportInProcess() {
      return ['pending', 'processing'].includes(this.status);
    },
    status() {
      return this.getStatusInfo?.status;
    },
  },
  mounted() {
    this.refreshStatus();
  },
  destroyed() {
    clearTimeout(this.refreshTimer);
  },
  methods: {
    refreshStatus() {
      if (['failed', 'completed'].includes(this.status)) return;
      this.refreshTimer = setTimeout(async () => {
        this.$store
          .dispatch('importWizard/importStatusSilent')
          .then(this.refreshStatus);
      }, 6000);
    },
    stopImport() {
      this.$store.dispatch('importWizard/stopImport');
    },
  },
};
</script>

<style scoped lang="scss"></style>
